import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { popUpMenuChange,
        selectedCardsGroupsChange,
        popUpMessageChange,
        deletedCardsGroupsChange } from '../../actions/index'

import Icon from '@mdi/react';
import { mdiDelete } from '@mdi/js';

import { _ } from '../../functions/translator'
import { CardsGroupStatus } from '../../constants/constants';
import { showMessage } from '../../functions/popUpMessage';


class DeleteButton extends React.Component{
          
    handleDelete = async () => {
        if (this.props.userRole.add_card) {
            const message = this.getMessage();
            const messageConfig = {
                closeButton: true,
                confirm: true
            }
            this.props.deletedCardsGroupsChange(this.props.cardsGroupIds)
            showMessage(this.props, message, messageConfig);
        } else {
            showMessage(this.props, _('No tienes permisos para eliminar protocolos'));
        }
        this.props.popUpMenuChange({ show: false })
        this.props.selectedCardsGroupsChange([])
    }

    getMessage() {
        let message = '';
        let openCardsGroupIds = this.props.cardsGroupIds.filter((cardsGroupId) => {
            let cardsGroupData = this.props.cardsGroupsData[cardsGroupId];
            if (!cardsGroupData) return false;
            let status = cardsGroupData.attributes.status;
            return status === CardsGroupStatus.OPEN;
        })
        if (openCardsGroupIds.length > 0) {
            message = `¿${_('Seguro que no deseas devolver estos protocolos a pendiente')}?`;
            let availableText = openCardsGroupIds.length > 1 ? _('disponibles') : _('disponible');
            message += ` (${openCardsGroupIds.length} ${availableText})`;
        } else {
            let count = this.props.cardsGroupIds.length;
            let protocolText = count > 1 ? _('protocolos') : _('protocolo');
            message = `¿${_('Estas seguro de eliminar')} ${count} ${protocolText}?`;
        }
        return message;
    }

    render(){   
        
        return (
            <div>
                <div className="popup-menu-button card-color" ref={ref => this.button = ref } onClick={this.handleDelete}>
                    <div className='d-inline-flex'>
                        <Icon path={ mdiDelete } size='30px' color='white' style={{margin: 10}}/>
                        <p>{ _('Eliminar') }</p>
                    </div>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        popUpMenu : state.popUpMenu,
        userRole  : state.userRole,
        cardsGroupsData : state.projectData.cards_groups
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({
        popUpMenuChange : popUpMenuChange,
        selectedCardsGroupsChange : selectedCardsGroupsChange,
        popUpMessageChange : popUpMessageChange,
        deletedCardsGroupsChange : deletedCardsGroupsChange
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(DeleteButton)